import { ReactComponent as CardIconSVG } from '@/assets/icons/CardIcon.svg';
import { SVGProps } from 'react';

const CardIcon = (props: SVGProps<SVGSVGElement>) => <CardIconSVG {...props} />;

export default CardIcon;
